export function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '全网最快',
      desc: '7×24小时监控全网动态，热点事件第一时间推送，比微博热搜快3步，让您领先所有人掌握最新爆料。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '真实可靠',
      desc: '严格核实每条线索来源，多方交叉验证后再发布，拒绝虚假信息和谣言传播，做有底线的吃瓜平台。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: '黑料吃瓜网入口支持PC端、手机版、平板全平台访问，最新地址自动适配屏幕，随时随地畅快吃瓜。',
    },
    {
      icon: 'ri-lock-line',
      title: '安全匿名',
      desc: '采用加密通道保护用户隐私，投稿人信息严格保密，浏览记录不追踪，让每位吃瓜群众安心围观。',
    },
  ];

  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-500">专业吃瓜，我们是认真的</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-300/50 transition-all duration-200"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  const items = [
    {
      title: '2024年度十大娱乐事件盘点',
      desc: '回顾这一年娱乐圈的风风雨雨，从顶流塌房到综艺翻车，全程高能不容错过。',
      tag: '年度策划',
      imageUrl: 'https://readdy.ai/api/search-image?query=Year%20end%20entertainment%20review%20collage%20with%20newspaper%20headlines%20and%20award%20ceremony%20elements%20dramatic%20lighting%20warm%20crimson%20and%20gold%20tones%20editorial%20design%20style%20cinematic%20composition%20no%20text&width=900&height=500&seq=carousel-01&orientation=landscape',
    },
    {
      title: '网红圈大地震：多个头部主播集体翻车',
      desc: '一场直播带货引发的连锁反应，涉及金额惊人，内幕远比想象中复杂。',
      tag: '深度追踪',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20bright%20ring%20lights%20and%20cameras%20tense%20atmosphere%20multiple%20screens%20showing%20comments%20warm%20dramatic%20lighting%20documentary%20style%20no%20text&width=900&height=500&seq=carousel-02&orientation=landscape',
    },
    {
      title: '选秀节目背后的资本游戏',
      desc: '当红选秀节目制作内幕大起底，投票机制、选手包装、导师选择都有不为人知的故事。',
      tag: '独家揭秘',
      imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlights%20and%20silhouettes%20behind%20the%20scenes%20atmosphere%20mysterious%20and%20suspenseful%20warm%20theatrical%20lighting%20cinematic%20wide%20shot%20no%20text&width=900&height=500&seq=carousel-03&orientation=landscape',
    },
    {
      title: '娱乐圈潜规则：那些不为人知的交易',
      desc: '多位圈内人士实名爆料，揭开娱乐圈光鲜亮丽背后的灰色地带和利益链条。',
      tag: '重磅曝光',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20backstage%20corridor%20with%20dramatic%20shadows%20and%20warm%20ambient%20light%20film%20noir%20aesthetic%20suspenseful%20atmosphere%20high%20contrast%20cinematic%20composition%20no%20text&width=900&height=500&seq=carousel-04&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度策划，一次吃够</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {items.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer bg-background-50"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold text-background-50 bg-primary-500">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="font-heading font-bold text-base md:text-lg text-background-50 mb-1 group-hover:text-accent-300 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-background-50/70 line-clamp-2 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  const topics = [
    { name: '顶流塌房', count: '12.8万', hot: true },
    { name: '直播翻车', count: '10.5万', hot: true },
    { name: '恋情曝光', count: '9.2万', hot: true },
    { name: '偷税漏税', count: '8.7万', hot: true },
    { name: '综艺内幕', count: '7.3万', hot: false },
    { name: '网红人设', count: '6.9万', hot: false },
    { name: '选秀黑幕', count: '6.1万', hot: false },
    { name: '私生活', count: '5.5万', hot: false },
    { name: '片酬争议', count: '4.8万', hot: false },
    { name: '品牌代言', count: '4.2万', hot: false },
    { name: '圈内潜规则', count: '3.9万', hot: false },
  ];

  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">大家都在讨论的瓜</p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className={`inline-flex items-center gap-1.5 px-3 md:px-4 py-2 md:py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                t.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 border border-background-200/70 hover:border-primary-300/50 hover:text-primary-600'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              <span>#{t.name}</span>
              <span className={`text-xs ${t.hot ? 'text-background-50/70' : 'text-foreground-400'}`}>
                {t.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  const cards = [
    {
      title: '某女星深夜密会神秘男子，两人举止亲密疑似恋情曝光',
      excerpt: '据知情人士透露，该女星近期频繁出入某高档小区，身边常有一位神秘男子陪同，两人互动自然亲密，不像是普通朋友关系。',
      time: '3小时前',
      views: '85.6万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20street%20photography%20blurred%20figures%20walking%20together%20warm%20street%20lights%20urban%20night%20scene%20intimate%20atmosphere%20soft%20glow%20cinematic%20mood%20no%20text&width=700&height=460&seq=card-01&orientation=landscape',
    },
    {
      title: '某知名导演新片选角规则曝光，背后利益链令人震惊',
      excerpt: '一位曾参与多部大制作的工作人员匿名爆料，揭露了电影选角过程中的灰色操作，涉及金额之庞大超出公众想象。',
      time: '5小时前',
      views: '72.3万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20cameras%20and%20equipment%20dim%20atmospheric%20lighting%20mysterious%20mood%20professional%20cinema%20environment%20warm%20dramatic%20tones%20no%20text&width=700&height=460&seq=card-02&orientation=landscape',
    },
    {
      title: '直播带货界大地震：三大头部主播被曝售卖假货',
      excerpt: '消费者实名举报，多位拥有千万粉丝的主播涉嫌销售假冒伪劣产品，目前相关部门已介入调查。',
      time: '8小时前',
      views: '68.9万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20shopping%20studio%20with%20products%20displayed%20on%20table%20bright%20ring%20lights%20tense%20atmosphere%20dramatic%20shadows%20warm%20lighting%20editorial%20style%20no%20text&width=700&height=460&seq=card-03&orientation=landscape',
    },
    {
      title: '某男团成员被曝私下恋爱多年，粉丝后援会集体脱粉',
      excerpt: '该偶像团体人气成员被拍到与圈外女友同居画面，粉丝大量脱粉，经纪公司至今未作回应。',
      time: '10小时前',
      views: '61.4万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Kpop%20style%20stage%20performance%20with%20colorful%20lights%20and%20silhouettes%20energetic%20atmosphere%20concert%20vibe%20dramatic%20backlighting%20warm%20theatrical%20glow%20no%20text&width=700&height=460&seq=card-04&orientation=landscape',
    },
    {
      title: '综艺节目录制现场突发冲突，两嘉宾当场翻脸',
      excerpt: '某热门综艺最新一期录制过程中，两位嘉宾因观点不合发生激烈争执，导致录制一度中断。',
      time: '12小时前',
      views: '55.8万',
      imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%20tense%20dramatic%20moment%20contrasting%20shadows%20reality%20show%20aesthetic%20warm%20professional%20lighting%20no%20text&width=700&height=460&seq=card-05&orientation=landscape',
    },
    {
      title: '娱乐圈税务风波再起：多位明星被约谈',
      excerpt: '继此前多位艺人因税务问题被处罚后，新一轮税务稽查已经展开，波及范围可能比上次更大。',
      time: '15小时前',
      views: '48.2万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20office%20building%20exterior%20with%20dramatic%20sky%20formal%20government%20style%20architecture%20serious%20atmosphere%20warm%20afternoon%20light%20professional%20photojournalism%20style%20no%20text&width=700&height=460&seq=card-06&orientation=landscape',
    },
    {
      title: '网红情侣分手互撕：聊天记录和转账截图全曝光',
      excerpt: '一对拥有数百万粉丝的网红情侣突然宣布分手，随后双方在社交平台互相爆料，吃瓜群众直呼精彩。',
      time: '18小时前',
      views: '42.7万',
      imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20chat%20interface%20with%20dramatic%20warm%20backlight%20intimate%20bedroom%20setting%20soft%20glow%20emotional%20atmosphere%20cinematic%20closeup%20no%20text&width=700&height=460&seq=card-07&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500">持续更新，精彩不断</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.slice(0, 6).map((card, i) => (
            <a
              key={i}
              href="#cards"
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer group flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200/80">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-4 md:mt-5">
          <div className="bg-background-100/70 rounded-xl p-4 md:p-5 border border-background-200/70">
            <a
              href="#cards"
              className="block cursor-pointer group"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-20 h-16 md:w-24 md:h-18 flex-shrink-0 rounded-lg overflow-hidden bg-background-200/80">
                  <img
                    src={cards[6].imageUrl}
                    alt={cards[6].title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                    {cards[6].title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                    {cards[6].excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{cards[6].time}</span>
                    <span>{cards[6].views} 阅读</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}